var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityWarningTriangleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning_triangle_fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.719 24.969l-12-20c-0.188-0.29-0.434-0.527-0.724-0.698l-0.010-0.005c-0.282-0.167-0.622-0.266-0.984-0.266s-0.702 0.099-0.994 0.271l0.009-0.005c-0.3 0.176-0.547 0.413-0.729 0.695l-0.005 0.008-12 20c-0.177 0.284-0.281 0.629-0.281 0.998 0 0.001 0 0.001 0 0.002v-0c0.001 0.377 0.093 0.732 0.256 1.044l-0.006-0.013c0.184 0.308 0.438 0.556 0.74 0.729l0.010 0.005c0.285 0.167 0.628 0.266 0.994 0.266 0.002 0 0.004 0 0.006 0h24c0.002 0 0.003 0 0.005 0 0.366 0 0.709-0.099 1.004-0.271l-0.009 0.005c0.312-0.178 0.566-0.427 0.745-0.725l0.005-0.009c0.157-0.3 0.249-0.655 0.25-1.031v-0c0-0.001 0-0.001 0-0.002 0-0.369-0.105-0.714-0.286-1.006l0.005 0.008zM17.066 23.066c-0.278 0.285-0.666 0.462-1.095 0.462-0.844 0-1.528-0.684-1.528-1.528s0.684-1.528 1.528-1.528c0.844 0 1.528 0.684 1.528 1.528v0c0 0.010 0 0.021 0 0.032 0 0.405-0.166 0.771-0.434 1.034l-0 0zM17 18h-2l-0.753-6.022c-0.009-0.066-0.014-0.141-0.014-0.218 0-0.972 0.788-1.76 1.76-1.76 0 0 0 0 0 0h0.013c0.972 0 1.76 0.788 1.76 1.76 0 0.077-0.005 0.153-0.015 0.227l0.001-0.009z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityWarningTriangleFill);
export default __webpack_public_path__ + "static/media/unity_warning_triangle_fill.e3820285e3208c19f4a460d3189efbaa.svg";
export { ForwardRef as ReactComponent };